import { BusinessCase, SUPPORTED_UNITS } from '@schuettflix/interfaces';
import { MarketCode } from '@schuettflix/utils';
import { generateBusinessCaseCustomProducts } from '@/shared/forms/CustomProductsForm/utils/generateBusinessCaseCustomProducts.ts';
import { getCompatibleProductTypes } from '@schuettflix/product-group-utils';

type ProductsByBusinessCaseParams = {
    businessCase: BusinessCase;
    marketCode: MarketCode;
    defaultTaxClass?: string;
    defaultBillingUnit?: SUPPORTED_UNITS;
};

export function resolveBusinessCaseProductConfiguration({
    businessCase,
    marketCode,
    defaultTaxClass,
    defaultBillingUnit,
}: ProductsByBusinessCaseParams) {
    const defaultBusinessCaseCustomProducts = generateBusinessCaseCustomProducts({
        businessCase,
        marketCode,
        defaultTaxClass,
        defaultBillingUnit,
    });

    const { compatibleProductTypes } = getCompatibleProductTypes({
        selectedProductGroupType: businessCase.pricingStrategy,
        selectedProductTypes: defaultBusinessCaseCustomProducts.map(product => product.productType),
    });

    return { supportedProducts: compatibleProductTypes, defaultBusinessCaseCustomProducts };
}
